import React from 'react';
import { Box } from '@withjoy/joykit';
import { ProductShelfCarousel } from '../../../ProductDetails/components/ProductShelfCarousel';
import { useRelatedProductCollectionsSection } from './RelatedProductCollectionsSection.controller';
import { RelatedProductCollectionsSectionArgs } from './types';
import { StyledRPCSectionContainer, styles } from './RelatedProductCollectionsSection.styles';
import { RelatedProductCollectionsSectionExtraArgs } from '../PdpSection/PdpSections.utils';

export const RelatedProductCollectionsSection = ({ extraArgs }: RelatedProductCollectionsSectionArgs) => {
  const { isMobile, isDialog, collectionDisplayInfos, selectedProductId, handleQuickAddCollectionItem, handleViewDetailsCollectionItem } =
    extraArgs as RelatedProductCollectionsSectionExtraArgs;
  const { collectionsList, loadingCollections, familyShelfRef } = useRelatedProductCollectionsSection({ collectionDisplayInfos: collectionDisplayInfos, selectedProductId });

  return (
    <StyledRPCSectionContainer
      ref={familyShelfRef}
      __css={styles.rpcSectionContainer}
    >
      {!!collectionDisplayInfos.length && (
        <>
          {loadingCollections && (
            <Box __css={styles.rpcSectionSkeleton}>
              <ProductShelfCarousel.Skeleton isMobile={isMobile} />
            </Box>
          )}
          {!loadingCollections &&
            !!collectionsList.length &&
            collectionsList.map(collection => (
              <Box
                key={collection.id}
                __css={styles.rpcSectionCarousel}
              >
                <ProductShelfCarousel
                  title={collection.title}
                  productsList={collection.items}
                  isDialog={isDialog}
                  onClickCard={handleViewDetailsCollectionItem}
                  onClickAdd={handleQuickAddCollectionItem}
                  sectionType={collection.pdpSectionType}
                />
              </Box>
            ))}
        </>
      )}
    </StyledRPCSectionContainer>
  );
};
